"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MissingItem = Symbol('MissingItem');

var randomOf_1 = require("./randomOf");

function randomList(list) {
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var requiredValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var requiredValuesPositions = requiredValues.map(function () {
    return -1;
  });
  var values = Array(items).fill(MissingItem);
  requiredValues.forEach(function (item, i) {
    var position;

    do {
      position = Math.floor(Math.random() * items);
    } while (requiredValuesPositions.includes(position));

    requiredValuesPositions[i] = position;
  });
  requiredValuesPositions.forEach(function (position, i) {
    values[position] = requiredValues[i];
  });
  return values.map(function (item) {
    if (item === MissingItem) {
      return randomOf_1.randomOf(list);
    }

    return item;
  });
}

exports.randomList = randomList;